// import axios from "../api/axios/axios";
// import useAuth from "./useAuth";
import axios from "../api/axios/axios";
import useStore from "./useStore";
import AppConstants from "../AppConstrains/AppConstrains";

const useRefreshToken = () => {
  const { setAuth } = useStore();

  const refresh = async () => {
    try {
      const response = await axios.get(`/api/auth/refresh`, {
        withCredentials: true,
      });
      // console.log(response, "response");

      setAuth((prev) => ({
        ...prev,
        role: response.data.role,
        accessToken: response.data.accessToken,
        email: response.data.email,
        modules: response.data.modules,
      }));

      return response.data.accessToken;
    } catch (error) {
      console.error(error);
    }
  };
  return refresh;
};
export default useRefreshToken;
